import { render, staticRenderFns } from "./ModalPayments.vue?vue&type=template&id=dd5f3ba8&"
import script from "./ModalPayments.vue?vue&type=script&lang=js&"
export * from "./ModalPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports